import React from 'react';
import Button from '@amzn/meridian/button';
import { Status } from '../../api/Notifications/schema';
import { TitleAndTag } from './commonShell/TitleAndTag';
import { DismissButton } from './commonShell/DismissButton';
import { generateRelativeUrl } from '../../config/Url';
import { useNavigate } from 'react-router';

interface NavigationalNotificationProps {
  key: string;
  externalId: string;
  title: string;
  message: string;
  timestamp?: string;
  dismissable: boolean;
  handleDismiss(id: string): void;
  notificationMetadata: {
    notificationCategory?: string;
    notificationType?: string;
  };
  text: string;
  link?: string;
  relativeLink?: string;
  status?: Status;
  onClose: () => void;
}

export const NavigationalNotification: React.FC<
  NavigationalNotificationProps
> = ({
  key,
  externalId,
  title,
  message,
  timestamp,
  dismissable,
  notificationMetadata,
  handleDismiss,
  text,
  link,
  relativeLink,
  status,
  onClose,
}: NavigationalNotificationProps): React.ReactElement => {
  const navigate = useNavigate();

  const redirectNav = (
    redirectLink?: string,
    redirectRelativeLink?: string
  ) => {
    if (redirectLink) {
      window.open(redirectLink, '_blank');
    } else if (redirectRelativeLink) {
      const url = generateRelativeUrl(redirectRelativeLink);
      navigate(url);
      onClose();
    }
  };

  return (
    <>
      <TitleAndTag
        title={title}
        message={message}
        timestamp={timestamp}
        status={status}
      />

      <span style={{ paddingLeft: '30px' }}>
        <DismissButton
          externalId={externalId}
          dismissable={dismissable}
          handleDismiss={handleDismiss}
          notificationMetadata={notificationMetadata}
        />
        <Button
          onClick={() => redirectNav(link, relativeLink)}
          type='primary'
          size='medium'
          data-csa-c-type='button'
          data-csa-c-slot-id='click-on-Action-button-slot'
          data-csa-c-content-id='click-on-Action-button'
          data-csa-c-description='Click on Notification Action button'
          data-csa-c-tag1='Notifications'
          data-csa-c-notification-category={
            notificationMetadata &&
            `${notificationMetadata.notificationCategory}`
          }
          data-csa-c-notification-type={
            notificationMetadata && `${notificationMetadata.notificationType}`
          }
          data-csa-c-notification-id={`${externalId}`}
        >
          {text}
        </Button>
      </span>

      <span style={{ paddingTop: '10px' }}></span>
    </>
  );
};
